import React from 'react';
import PropTypes from 'prop-types';
import I18n from '../i18n';
import NavItem from './nav-item';

export default function Group(props) {
  const {applicationId, navData, onStatusChange} = props;
  const {name, children} = navData;

  return (
    <React.Fragment>
      <li className="grouping">
        <I18n t={name} />
      </li>
      {children.map(child => (
        <NavItem navData={child} key={`${applicationId}.${child.id}`} onStatusChange={onStatusChange} />
      ))}
    </React.Fragment>
  );
}

Group.propTypes = {
  /** The id of the application that this group belongs to. */
  applicationId: PropTypes.string.isRequired,
  /** The navigation data to render. */
  navData: PropTypes.object.isRequired,
  /** A callback to execute when the status changes. Passes the status string. */
  onStatusChange: PropTypes.func.isRequired,
};
